// Centralised path helpers for entity detail pages.

export function actorDetailPath(name: string): string {
  return `/actors/${encodeURIComponent(name)}`;
}

export function familyDetailPath(name: string): string {
  return `/families/${encodeURIComponent(name)}`;
}

export function techniqueDetailPath(attackId: string): string {
  return `/techniques/${encodeURIComponent(attackId)}`;
}

export function iocDetailPath(value: string, type?: string): string {
  const base = `/ioc/${encodeURIComponent(value)}`;
  return type ? `${base}?type=${encodeURIComponent(type)}` : base;
}

export function countryDetailPath(code: string): string {
  return `/country/${encodeURIComponent(code.toUpperCase())}`;
}

/** Detail page of an /explore/search result (actor, family, technique, country, IOC/CVE). */
export function entityDetailPath(item: {
  value: string; category: string; extra?: Record<string, unknown> | null;
}): string {
  switch (item.category) {
    case 'country': return countryDetailPath(item.value);
    case 'actor': return actorDetailPath(item.value);
    case 'family': return familyDetailPath(item.value);
    case 'technique':
      return techniqueDetailPath(item.extra?.attack_id ? String(item.extra.attack_id) : item.value);
    default: return iocDetailPath(item.value, item.category);
  }
}

/** The /search results page for a query (query-language syntax allowed). */
export function searchPath(query: string): string {
  return `/search?q=${encodeURIComponent(query.trim())}`;
}
